import { render, staticRenderFns } from "./Dreambuild.vue?vue&type=template&id=67f4f3d6"
import script from "./Dreambuild.vue?vue&type=script&lang=js"
export * from "./Dreambuild.vue?vue&type=script&lang=js"
import style0 from "./Dreambuild.vue?vue&type=style&index=0&id=67f4f3d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports